import React, { useState,useEffect } from "react";
import {
  Grid,
  Card,
  Tabs,
  Tab,
  Box,
  TextField,
  Button,
  Backdrop,
  CircularProgress
} from "@mui/material";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import DataTable from "examples/Tables/DataTable";

import { url ,fileUploadUrl} from "../../constant";

function FooterSectionDashboard() {
  const [tab, setTab] = useState(0);

  const [sections, setSections] = useState([
    {
      id: 1,
      section_title: "About Us",
      links: ["Privacy Policy", "Terms of Service", "Contact Us"]
    },
    {
      id: 2,
      section_title: "Resources",
      links: ["Blog", "Help Center", "API Docs"]
    }
  ]);

  const [formState, setFormState] = useState({
    section_title: "",
    
  });
  const [editId, setEditId] = useState(null);
  const [loading, setLoading] = useState(false);
  const [formLoading, setFormLoading] = useState(false);
  const [currentPageIndex, setCurrentPageIndex] = useState(0); // Manage pagination state


  useEffect(() => {
    fetchSections();
  }, []);


  const fetchSections = async () => {
    try {
      setLoading(true);
      const res = await fetch(`${url}auth/get-footer-sections`);
      if (!res.ok) throw new Error(`Error: ${res.status}`);

      const data = await res.json();

      console.log("get-footer-sections", data);

      setSections(data);
    } catch (err) {
      console.log("err", err);
    } finally {
      setLoading(false);
    }
  };


  const columns = [
    { Header: "ID", accessor: "id" },
    { Header: "Section Title", accessor: "section_title" },
    // {
    //   Header: "Links",
    //   accessor: "links",
    //   Cell: ({ value }) => value.join(", ")
    // },
    {
      Header: "Actions",
      accessor: "actions",
      Cell: ({ row }) => (
        <>

          <Button
            variant="contained"
            size="small"
            sx={{ backgroundColor: "#183759", color: "#fff", "&:hover": { backgroundColor: "#204b80" } }}
            onClick={() => {
              setFormState({
                section_title: row.original.section_title,
                // linksText: row.original.links.join(", ")
              });
              setEditId(row.original.id);
              setTab(1);
            }}
          >
            Modifica
          </Button>

        

          {/* Delete Button */}
          {/* <Button
            variant="contained"
            color="error"
            size="small"
             onClick={() => handleDelete(row.original.id)}
            sx={{
              fontWeight: 'bold',
              padding: '8px 16px',
              backgroundColor: '#d32f2f',
              color: '#fff',
              '&:hover': { backgroundColor: '#c62828' },
              marginLeft:2
            }}
            
          >
            
            Cancella
          </Button> */}

        </>
        
      )
    }
  ];

  const rows = sections.map((s) => ({ ...s, actions: "" }));


  const handleSave = async () => {
    setLoading(true);

    const payload = {
      section_title: formState.section_title,
    };

    try {
      let res;
      if (editId) {
        // Update existing
        res = await fetch(`${url}auth/update-footer-section/${editId}`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(payload),
        });
      } else {
        // Create new
        res = await fetch(`${url}auth/create-footer-section`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(payload),
        });
      }

      if (!res.ok) {
        throw new Error(`Failed to save: ${res.status}`);
      }

      const savedSection = await res.json();
     

      // Update local state after save
      if (editId) {
        setSections((prev) =>
          prev.map((s) =>
            s.id === editId ? { ...s, section_title: formState.section_title } : s
          )
        );
      } else {
        fetchSections();
      }

      // Reset form & switch tab
      setFormState({ section_title: "" });
      setEditId(null);
      setTab(0);
    } catch (err) {
      console.error(err);
    } finally {
     setLoading(false);
    }
  };


  const handleDelete = async (id) => {
    if (!window.confirm("Sei sicuro di voler eliminare questa sezione?")) {
      return; // User cancelled deletion
    }

    setLoading(true);
    try {
      const res = await fetch(`${url}auth/delete-footer-section/${id}`, {
        method: "DELETE",
      });

      if (!res.ok) {
        // Try to parse error message from backend
        const errorData = await res.json().catch(() => null);
        const errorMessage =
          (errorData && errorData.message) || `Failed to delete: ${res.status}`;

        throw new Error(errorMessage);
      }

      // Successfully deleted
      setSections((prev) => prev.filter((section) => section.id !== id));

      if (editId === id) {
        setFormState({ section_title: "" });
        setEditId(null);
        setTab(0);
      }
    } catch (err) {
      console.error(err);
      alert(err.message || "Errore durante l'eliminazione della sezione.");
    } finally {
      setLoading(false);
    }
  };



  // const handleDelete = async (id) => {
  //   if (!window.confirm("Sei sicuro di voler eliminare questa sezione?")) {
  //     return; // User cancelled deletion
  //   }

  //   setLoading(true);
  //   try {
  //     const res = await fetch(`${url}auth/delete-footer-section/${id}`, {
  //       method: "DELETE", // Use DELETE method for deletion
  //     });

  //     if (!res.ok) {
  //       throw new Error(`Failed to delete: ${res.status}`);
  //     }

  //     // Remove the deleted section from local state
  //     setSections((prev) => prev.filter((section) => section.id !== id));

  //     // Optional: Reset form if editing the deleted item
  //     if (editId === id) {
  //       setFormState({ section_title: "" });
  //       setEditId(null);
  //       setTab(0);
  //     }
  //   } catch (err) {
  //     console.error(err);
  //     alert("Errore durante l'eliminazione della sezione.");
  //   } finally {
  //     setLoading(false);
  //   }
  // };



  return (
    <DashboardLayout>
      <DashboardNavbar />

      <Backdrop open={loading || formLoading} sx={{ zIndex: 1000 }}>
        <CircularProgress color="inherit" />
      </Backdrop>

      <MDBox pt={6} pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Card>
              <MDBox
                mx={2}
                mt={-3}
                py={3}
                px={2}
                variant="gradient"
                bgColor="#183759"
                borderRadius="lg"
                coloredShadow="info"
              >
                <MDTypography variant="h6" color="white">
                  Footer Sections
                </MDTypography>
              </MDBox>

              <Tabs value={tab} onChange={(e, val) => setTab(val)} variant="fullWidth">
                <Tab label="Elenco Sezioni" />
                {/* <Tab label={editId ? "Modifica Sezione" : "Nuova Sezione"} /> */}

                {editId && <Tab label="Modifica Sezione" />}

              </Tabs>

              {tab === 0 && (
                <MDBox pt={3}>
                  <DataTable
                    table={{ columns, rows }}
                    isSorted={false}
                    entriesPerPage={{ defaultValue: 10 }}
                    showTotalEntries={false}
                    noEndBorder
                    currentPageIndex={currentPageIndex}
                    setCurrentPageIndex={setCurrentPageIndex}
                  />
                </MDBox>
              )}

              {tab === 1 && (
                <MDBox pt={3} px={2}>
                  <Grid container justifyContent="center">
                    <Grid item xs={12} sm={8} md={6}>
                      <TextField
                        label="Section Title"
                        fullWidth
                        value={formState.section_title}
                        onChange={(e) => setFormState({ ...formState, section_title: e.target.value })}
                        sx={{ mb: 2 }}
                      />
                      {/* <TextField
                        label="Links (comma separated)"
                        fullWidth
                        value={formState.linksText}
                        onChange={(e) => setFormState({ ...formState, linksText: e.target.value })}
                        sx={{ mb: 2 }}
                        helperText="e.g. Privacy Policy, Terms, Contact"
                      /> */}
                      <Button
                        variant="contained"
                        fullWidth
                        onClick={handleSave}
                        sx={{ mb:5, backgroundColor: "#183759", color:"#fff", "&:hover": { backgroundColor: "#204b80" } }}
                      >
                        {editId ? "Aggiorna" : "Salva"}
                      </Button>
                    </Grid>
                  </Grid>
                </MDBox>
              )}
            </Card>
          </Grid>
        </Grid>
      </MDBox>

      <Footer />
    </DashboardLayout>
  );
}

export default FooterSectionDashboard;
